export const getImageUrl = (path) => {
    return process.env.IMAGE_URL + path;
};
